let TIMEZONE = (() => {
    const tz = new Date().getTimezoneOffset()
    const tz_hours = parseInt(tz / 60)
    const tz_minutes = tz % 60
    const sign = tz_hours > 0 ? '-' : ''

    return `${sign}${('0' + tz_hours).slice(-2)}:${('0' + tz_minutes).slice(-2)}`
})()

class ElectricMeter {
    constructor(axiosClient) {
        this.axios = axiosClient
    }

    lastData(device, len, start, end, timezone) {
        timezone = timezone || TIMEZONE
        len = len || 10

        let endpoint = `/devices/${device}/functions/ElectricMeter/measurements?len=${len}&timezone=${timezone}`
        if (start) endpoint += `&since=${start.getTime()}`
        if (end) endpoint += `&until=${end.getTime()}`
        
        return this.axios.get(endpoint)
    }

    summaryData(device, type, start, timezone) {
        timezone = timezone || TIMEZONE

        return this.axios.get(
            `/devices/${device}/functions/ElectricMeter/measurements/summary/${type}?start=${start}&timezone=${timezone}`
        )
    }
}

export default ElectricMeter
